import AppContext from '@aurora/shared-client/components/context/AppContext/AppContext';
import { EndUserPages } from '@aurora/shared-types/pages/enums';
import dynamic from 'next/dynamic';
import React, { useContext } from 'react';
import MessagePage from '../../../components/page/MessagePage/MessagePage';

const QAPageSchema = dynamic(() => import('../../../components/seo/QAPageSchema/QAPageSchema'));

/**
 * Forum Message Page
 *
 * @author Stephen McLaughry, Adam Ayres
 */
const ForumMessagePage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isCrawler, contextMessage } = useContext(AppContext);

  return (
    <>
      <MessagePage pageId={EndUserPages.ForumMessagePage} />
      {contextMessage && isCrawler && <QAPageSchema />}
    </>
  );
};
export default ForumMessagePage;
